<template>
  <div id="app">
    <base-layout/>
  </div>
</template>

<style lang="scss">
  #app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #333333;
    font-size: 14px;
  }
</style>
<script>
  import BaseLayout from "./components/layout/BaseLayout";
  export default {
    components: {BaseLayout}
  }

</script>
